const SEPARATORS = ['.', ':'];

export const formatMinutes = (minutes: number) =>
  `${Math.floor((minutes / 60) % 24)
    .toString()
    .padStart(2, '0')}:${(minutes % 60).toString().padStart(2, '0')}`;

export const parseMinutes = (input: string) => {
  const sanitized = input.replace(new RegExp(`[^0-9${SEPARATORS.join('')}]`, 'gi'), '');
  let hoursStr = '';
  let minutesStr = '';

  if (
    (sanitized.length === 3 || sanitized.length === 4) &&
    !SEPARATORS.some(separator => sanitized.includes(separator))
  ) {
    const paddedTimeStr = sanitized.padStart(4, '0');
    hoursStr = paddedTimeStr.slice(0, 2);
    minutesStr = paddedTimeStr.slice(2, 4);
  } else {
    const split = sanitized.split(/\.|:/);
    [hoursStr] = split;
    if (split[1]) {
      minutesStr = split[1].padEnd(2, '0');
    }
  }

  const hours = parseInt(hoursStr, 10);
  const minutes = parseInt(minutesStr, 10) || 0; // Allow user to omit minutes
  if (isNaN(hours)) {
    return null;
  }
  if (hours < 0 || hours >= 24) {
    return null;
  }
  if (minutes < 0 || minutes >= 60) {
    return null;
  }
  return hours * 60 + minutes;
};
